export default "/assets/images/whitenoise-mode.webm?b51c681969de126a8e9f02b0dddaaba3";